export const MAX_UPLOAD_COUNT = 25;
export const MAX_UPLOAD_SIZE = 20000000;

export const MAX_UPLOAD_SIZE_DISPLAY = `${MAX_UPLOAD_SIZE / 1000000} MB`;

export const ATTACHMENT_DROP_ZONE_HEADING = 'Drop your files here';

export const ATTACHMENT_UPLOAD_GUIDELINES = `You can select up to ${MAX_UPLOAD_COUNT} image, video, Word, Excel, text, HTML, \
        or non-password protected PDF files. All files must total less than ${MAX_UPLOAD_SIZE_DISPLAY}.`;

export const FILE_TYPES = {
  IMAGE: 'image', // use with .includes since an image can be image/jpg, image/png, etc.
  VIDEO: 'video', // use with .includes since a video can be .mp4, .mov, etc.
};

export const ATTACHMENT_STATUS = {
  IMPERSONATION_DETECTED: 'impersonation-detected',
  STATUS_COMPLETE: 'complete',
};

export const ACCEPTED_FILE_TYPES =
  'image/*, video/*, .pdf, .HTML, .text, .txt, .rtf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const ACCEPTED_FILE_TYPES_DETAILED =
  'image/jpeg, image/gif, image/avif, image/png, image/svg+xml, image/apng, image/heif, image/heif-sequence, image/heic, image/heic-sequence, video/*, .pdf, .HTML, .text, .txt, .rtf, .doc, .docx, .xls, .xlsx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const FILE_UPLOAD_ERROR_MESSAGE =
  'An error has occurred preventing file uploads. Please try refreshing the page.';

// Attachment upload errors, keyed by cause so each toast names the corrective action.
export const MAX_UPLOAD_COUNT_ERROR_MESSAGE = `File couldn’t be uploaded. Send up to ${MAX_UPLOAD_COUNT} files per message and try again.`;
export const MAX_UPLOAD_SIZE_ERROR_MESSAGE = `File couldn’t be uploaded. Keep files under ${MAX_UPLOAD_SIZE_DISPLAY} and try again.`;
export const DUPLICATE_FILE_UPLOAD_ERROR_MESSAGE =
  'File couldn’t be uploaded. Remove the duplicate file and try again.';
export const FILE_UPLOAD_CONNECTION_ERROR_MESSAGE = 'File couldn’t be uploaded. Check your connection and try again.';
